<template>
  <div class="container">
    <app-header title="供应商服务协议"/>
    <div class="main">
      <div v-html="supplierAgreement"></div>
    </div>
  </div>
</template>

<script>

  import {getSysSetting} from '@/api/system/index.js'
  export default {
    name: 'agreement',
    data() {
      return {
        show: false,
        supplierAgreement: ''
      }
    },
    created(){
      this.getSysSetting();
    },
    methods: {
      getSysSetting(){
        getSysSetting({id: 1}).then(res=>{
          if (res.success) {
            this.supplierAgreement = res.data.supplierAgreement
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .container {
    .main {
      flex-direction: column;
      justify-content: center;
      text-align: center;
      margin-top: 41px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/business/login/agreement.vue